import BotDialogType from '../../core/type/dialog/BotDialogType';
import TextInputType from '../../core/type/input/TextInputType';
import UserDialogType from '../../core/type/dialog/UserDialogType';
import Case from '../../core/type/operation/Case';
import Switch from '../../core/type/operation/Switch';
import { sendBotResponse } from './util';
import RaterInputType from '../../core/type/input/RaterInputType';
import Interceptor from '../../core/type/operation/Interceptor';
import SelectorInputType from '../../core/type/input/SelectorInputType';

export default [

  new BotDialogType({
    message: 'Certo. E quanto você está satisfeito com a situação atual das áreas a seguir dentra da sua empresa.',
    checkpoint: true,
  }),

  new RaterInputType({
    key: 'difficulties',
    options: 'option_stars',
  }),

  new BotDialogType({
    message: '',
    checkpoint: true,
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, difficulties: data.difficulties },
      difficulties: data.difficulties
        ?.map((o) => `${o.text}: ${o.value}`)
        .join(', '),
    });
  })),

  new BotDialogType({
    message: '',
    checkpoint: true,
  }),

  new UserDialogType({
    message: '#{difficulties}',
  }),

  new BotDialogType({
    message: 'Na sua estrutura atual, quantos profissionais estão <b>100% focados em marketing</b>?',
    checkpoint: true,
  }),

  new TextInputType({
    placeholder: 'Digite um número.',
    mask: '999999',
    key: 'number_employee_marketing',
    suggestionsId: 'number_employee_suggestions',
    numberMode: true,
  }),

  sendBotResponse(),

  new UserDialogType({
    message: 'Possuo <b>#{number_employee_marketing}</b> profissionais focados 100% em marketing',
  }),

  new Switch({
    ref: 'number_employee_marketing',
    cases: [
      new Case({
        express: '$v == 0',
        components: [
          new BotDialogType({
            message: 'Entendido! Essa é a oportunidade certa para que a sua empresa comece a trazer mais atenção para marketing. Vamos lá!',
          }),
        ],
      }),
      new Case({
        express: '$v > 0 && $v <= 3',
        components: [
          new BotDialogType({
            message: `Legal! Ter um time focado em marketing, mostra que a sua empresa entende sobre a 
            importância de investimentos para o crescimento do negócio.`,
          }),
        ],
      }),
      new Case({
        express: '$v > 3',
        components: [
          new BotDialogType({
            message: 'Excelente! Você já está em um estágio a frente quando o assunto é marketing.',
          }),
        ],
      }),
    ],
  }),

  // START -> Comercial
  new BotDialogType({
    message: 'E no seu time hoje, quantas pessoas se dedicam <b>exclusivamente para vendas?</b>',
    checkpoint: true,
  }),

  new TextInputType({
    placeholder: 'Digite um número.',
    mask: '999999',
    key: 'number_employee_sale',
    suggestionsId: 'number_employee_suggestions',
    numberMode: true,
  }),

  new UserDialogType({
    message: 'Possuo <b>#{number_employee_sale}</b> profissionais focados 100% em vendas',
    checkpoint: true,
  }),

  new Switch({
    ref: 'number_employee_sale',
    cases: [
      new Case({
        express: '$v == 0',
        components: [
          new BotDialogType({
            message: `Entendido!
            Talvez essa seja a oportunidade para que a sua empresa comece a trazer mais atenção para vendas. Vamos continuar. `,
          }),
        ],
      }),
      new Case({
        express: '$v > 0 && $v <= 3',
        components: [
          new BotDialogType({
            message: 'Legal! Ter profissionais focados em vendas faz com que vocês tenham mais consistência nos resultados comerciais.',
          }),
        ],
      }),
      new Case({
        express: '$v > 3 && $v <= 6',
        components: [
          new BotDialogType({
            message: 'Muito legal! Você já possui uma estrutura boa.',
          }),
        ],
      }),
      new Case({
        express: '$v > 6',
        components: [
          new BotDialogType({
            message: 'Entendi, você já possui uma boa estrutura comercial.',
          }),
        ],
      }),
    ],
  }),

  // END -> Comercial

  // START -> SLA
  new BotDialogType({
    message: 'Na sua empresa, existe algum acordo formal entre as áreas de Marketing e Vendas sobre as responsabilidades de cada time?',
    checkpoint: true,
  }),

  new SelectorInputType({
    key: 'company_sla',
    type: 'radio',
    column: 'half',
    options: 'option_sla',
  }),

  new UserDialogType({
    message: '#{company_sla.text}',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, company_sla: data.company_sla },
      company_sla: data.company_sla.text,
    });
  })),

  new BotDialogType({
    message: '',
    checkpoint: true,
  }),

  sendBotResponse(),
];
